import { checkRole } from '@/router/guards.ts'

const LoginHistoryModule = () => import('./LoginHistoryModule.vue')
const LoginHistoriesIndex = () => import('./views/LoginHistoriesIndex.vue')
const LoginHistoryIndex = () => import('./views/LoginHistoryIndex.vue')

export const loginHistoryRoute = {
  path: '/login-history',
  name: 'LoginHistory',
  component: LoginHistoryModule,
  meta: {
    title: 'LoginHistory',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'LoginHistoriesIndex',
      meta: {
        permission: 'loginHistory.view',
      },
      beforeEnter: checkRole('super-admin'),
      component: LoginHistoriesIndex,
    },
    {
      path: 'me',
      name: 'LoginHistoryIndex',
      meta: {
        permission: 'loginHistory.view',
      },
      component: LoginHistoryIndex,
    },
  ],
}
